import { render, staticRenderFns } from "./SelectorClienteVigente.vue?vue&type=template&id=3bfd2d5b&scoped=true"
import script from "./SelectorClienteVigente.vue?vue&type=script&lang=js"
export * from "./SelectorClienteVigente.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bfd2d5b",
  null
  
)

export default component.exports